// extracted by mini-css-extract-plugin
module.exports = {"explain":"Explain_explain__1ymyQ","content":"Explain_content__3d5O_","close":"Explain_close__3QLWx"};